import { createSelector } from "@reduxjs/toolkit";

export const isSysAdminSelector = createSelector<[(state: LSStore.State) => LSCommon.Models.UserJsModel], boolean>(state => state.user.value, user => user.roles.some(x => x == LSCommon.MemberRole.SysAdmin));
